import React from 'react';
import { Mail, Phone, Linkedin, Award, GraduationCap, Briefcase } from 'lucide-react';
import { profileData, experience, achievements, education, certifications, competencies } from '../mock';

const Experience = () => {
  return (
    <div className="page-container">
      {/* Profile Header */}
      <section className="profile-header">
        <div className="profile-info">
          <h1 className="display-large">{profileData.name}</h1>
          <p className="heading-2 profile-title">{profileData.title}</p>
          <p className="body-large profile-summary">{profileData.summary}</p>
          
          <div className="profile-contact">
            <a href={`mailto:${profileData.email}`} className="contact-link">
              <Mail size={20} />
              <span>{profileData.email}</span>
            </a>
            <a href={`tel:${profileData.phone}`} className="contact-link">
              <Phone size={20} />
              <span>{profileData.phone}</span>
            </a>
            <a 
              href={profileData.linkedin} 
              target="_blank" 
              rel="noopener noreferrer"
              className="contact-link"
            >
              <Linkedin size={20} />
              <span>LinkedIn Profile</span>
            </a>
          </div>
        </div>
      </section>

      {/* Core Competencies */}
      <section className="content-section">
        <div className="section-header">
          <Award size={32} />
          <h2 className="display-medium">Core Competencies</h2>
        </div>
        <div className="competencies-grid">
          {competencies.map((competency, index) => (
            <div key={index} className="competency-tag">
              {competency}
            </div>
          ))}
        </div>
      </section>

      {/* Selected Achievements */}
      <section className="content-section">
        <div className="section-header">
          <h2 className="display-medium">Selected Achievements</h2>
        </div>
        <div className="achievements-container">
          {achievements.map((achievement, index) => (
            <div key={index} className="achievement-section">
              <h3 className="heading-2">{achievement.category}</h3>
              <ul className="achievement-list">
                {achievement.items.map((item, idx) => (
                  <li key={idx} className="body-medium">{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      {/* Professional Experience */}
      <section className="content-section">
        <div className="section-header">
          <Briefcase size={32} />
          <h2 className="display-medium">Professional Experience</h2>
        </div>
        <div className="experience-timeline">
          {experience.map((exp, index) => (
            <div key={index} className="experience-card">
              <div className="experience-header">
                <div>
                  <h3 className="heading-2">{exp.company}</h3>
                  <p className="heading-3 experience-role">{exp.role}</p>
                  <p className="body-small experience-meta">
                    {exp.location} | {exp.dates}
                    {exp.team && ` | Team: ${exp.team}`}
                  </p>
                </div>
              </div>
              <ul className="experience-list">
                {exp.responsibilities.map((resp, idx) => (
                  <li key={idx} className="body-medium">{resp}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      {/* Education */}
      <section className="content-section">
        <div className="section-header">
          <GraduationCap size={32} />
          <h2 className="display-medium">Education</h2>
        </div>
        <div className="education-container">
          {education.map((edu, index) => (
            <div key={index} className="education-card">
              <h3 className="heading-3">{edu.degree}</h3>
              <p className="body-medium">{edu.institution}</p>
              {edu.specialization && (
                <p className="body-small education-spec">{edu.specialization}</p>
              )}
              {edu.location && (
                <p className="body-small text-muted">{edu.location}</p>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* Certifications */}
      <section className="content-section">
        <div className="section-header">
          <h2 className="display-medium">Certifications</h2>
        </div>
        <ul className="certification-list">
          {certifications.map((cert, index) => (
            <li key={index} className="body-medium certification-item">{cert}</li>
          ))}
        </ul>
      </section>
    </div>
  );
};

export default Experience;
